



















import Vue from "vue"
import * as api from '@/api/firebase'


export default Vue.extend({


	data() {
		return {
			email:"",
			sending: false,
		}
	},

	methods: {
		async go() {
			console.log(this.$route.query)
			this.sending = true;
			const { success, error } = await api.signIn(this.email, this.$route.query.then as string);
			this.sending = false;
			if(success) {
				this.$router.push("/mailsent")
			} else {
				this.$store.commit("alert/addMessage", error)
			}
		},

		signout() {
			api.signOut();
		}
	}
})
